import axios from "axios"
import { fixDir } from "./dom"

const host = window.location.host
const isDev = false // process.env.NODE_ENV === "development"
const regions = [{
  region: "cnbj1",
  hostPrefix: ""
}, {
  region: "cnbj1",
  hostPrefix: "pv"
}, {
  // 美国
  region: "awsusor1",
  hostPrefix: "us"
}, {
  // 印度
  region: "awsind0-fusion",
  hostPrefix: "i2"
}, {
  // 新加坡
  region: "alsgp0",
  hostPrefix: "sg"
}, {
  // 德国
  region: "awsde0-fusion",
  hostPrefix: "de"
}, {
  // 俄罗斯
  region: "ksyru0-fusion",
  hostPrefix: "ru"
}]

function getRegionStruct() {
  if (isDev) {
    return regions[0]
  }
  const prefix = host.replace("watch.iot.mi.com", "").replace('watch.xiaomiwear.com', '')
  if (!prefix || prefix === 'st-') {
    return regions[0]
  }
  return regions.find(t => `${t.hostPrefix}.` === prefix)
}

function getRegion() {
  const r = getRegionStruct()
  return r?.region
}

export const fdsRegion = getRegion()

export const regionCode = getRegionStruct()?.hostPrefix || 'cn'

export const base = window.location.pathname.replace(/.*\/html\//, "").replace("/index.html", "").replace("/", "")

export const sourcePrefix = isDev ? "" : (fdsRegion ? `https://${fdsRegion}.fds.api.xiaomi.com/miwear-docs` : '')
//export const sourcePrefix = isDev ? "" : "https://web-global.mi-fds.net/miwear-docs"
export const getFdsPath = (path: string) => path ? sourcePrefix + path : ""
axios.defaults.baseURL = sourcePrefix
export async function getData(source: string) {
  try {
    const res = await axios.get(source)
    return res.data
  } catch {
    console.error(`load ${source} failed.`)
    return undefined
  }
}
export async function _load(source: string) {
  const res = await getData(source)
  return res
}

export async function load(source: string, fallback: Array<string> = [], json = false) {

  const r0 = await _load(source)
  if (r0) return r0

  console.error('网络差或者没有该locale');

  fixDir(source)

  for (const fb of fallback) {
    const r1 = await _load(fb)
    if (r1) return r1
  }
  return undefined
}
